import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { maxConcurrentConnectionsMetadata, preCopyScriptMetadata } from '../consts/metadata-consts';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';

export const informixTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.informix.datasetType,
    displayName: stringResources.InformixTable_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.informix.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-ibm'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    copySinkControls: [
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                defaultValue: 0,
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ]
};
